export function loadProductOptionsAvailabilityMapper() {
	return import(
		'@wix/wixstores-platform-common/dist/src/productOptionsAvailability/productOptionsAvailability.mapper' /* webpackChunkName: "storesWixCodeVendors" */
	)
}

export function loadProductVariantsMapper() {
	return import(
		'@wix/wixstores-platform-common/dist/src/productVariants/productVariants.mapper' /* webpackChunkName: "storesWixCodeVendors" */
	)
}

export function loadCartMapper(): Promise<
	typeof import('@wix/wixstores-platform-common/dist/src/carts/cart.mapper.client')
> {
	return import(
		'@wix/wixstores-platform-common/dist/src/carts/cart.mapper.client' /* webpackChunkName: "storesWixCodeVendors" */
	)
}

export function loadAmbassadorWixEcomCatalogReaderWebHttp() {
	return import(
		// @ts-ignore
		'@wix/ambassador-wix-ecommerce-catalog-reader-web-http/http' /* webpackChunkName: "storesWixCodeVendors" */
	)
}
